export const DEFAULT_FIELD_ICON_NAMES = {
  first_name: "user",
  last_name: "name-card",
  email: "mail",
  phone: "phone",
  address1: "map-pin",
  address2: "apartment",
  city: "city",
  province_code: "map",
  country_code: "globe",
  postal_code: "postal-code",
  discount_code: "discount",
};

export const defaultFieldIconName = (fieldName) =>
  DEFAULT_FIELD_ICON_NAMES[fieldName] || "user";

const ICON_CONTENT = {
  user: (
    <>
      <circle cx="12" cy="8" r="3.25" />
      <path d="M5.75 19.25c.45-3.15 2.78-5.25 6.25-5.25s5.8 2.1 6.25 5.25" />
    </>
  ),
  "name-card": (
    <>
      <rect x="3" y="5" width="18" height="14" rx="2.25" />
      <circle cx="8" cy="10" r="2" />
      <path d="M5.5 15c.35-1.75 1.25-2.75 2.5-2.75s2.15 1 2.5 2.75M13.5 9h4M13.5 12h4M13.5 15h2.5" />
    </>
  ),
  mail: (
    <>
      <rect x="3.5" y="5.5" width="17" height="13" rx="2.25" />
      <path d="m5 7 7 5.25L19 7" />
    </>
  ),
  phone: (
    <path d="M7.15 3.75 9.6 7.2 7.9 9.45a15.1 15.1 0 0 0 6.65 6.65l2.25-1.7 3.45 2.45-.7 3.05c-.17.72-.83 1.22-1.57 1.17C10.1 20.55 3.45 13.9 2.88 6.02a1.5 1.5 0 0 1 1.17-1.57l3.1-.7Z" />
  ),
  "map-pin": (
    <>
      <path d="M19 10c0 4.75-7 10.25-7 10.25S5 14.75 5 10a7 7 0 1 1 14 0Z" />
      <circle cx="12" cy="10" r="2.35" />
    </>
  ),
  apartment: (
    <>
      <path d="M5 20V5.5A1.5 1.5 0 0 1 6.5 4h7A1.5 1.5 0 0 1 15 5.5V20M15 9h2.5A1.5 1.5 0 0 1 19 10.5V20M3 20h18" />
      <path d="M8 7.5h1M11.5 7.5h1M8 11h1M11.5 11h1M8 14.5h1M11.5 14.5h1M8.5 20v-2.5h3V20" />
    </>
  ),
  city: (
    <>
      <path d="M3 20h18M5 20V9h5v11M10 20V4h6v16M16 20v-8h3v8" />
      <path d="M7.5 12h.01M7.5 15h.01M13 7h.01M13 10h.01M13 13h.01M13 16h.01" />
    </>
  ),
  map: (
    <>
      <path d="m3.5 6.25 5-2.25 7 2.25 5-2.25v13.75l-5 2.25-7-2.25-5 2.25V6.25Z" />
      <path d="M8.5 4v13.75M15.5 6.25V20" />
    </>
  ),
  globe: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.75 12h16.5M12 3.5c2.15 2.25 3.25 5.08 3.25 8.5S14.15 18.25 12 20.5C9.85 18.25 8.75 15.42 8.75 12S9.85 5.75 12 3.5Z" />
    </>
  ),
  "postal-code": (
    <>
      <rect x="3.5" y="5" width="17" height="14" rx="2.25" />
      <path d="M3.75 8.25h16.5M7 12h5M7 15.5h7M17 12h.01" />
    </>
  ),
  discount: (
    <>
      <path d="M4 5h16a1 1 0 0 1 1 1v3a3 3 0 0 0 0 6v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3a3 3 0 0 0 0-6V6a1 1 0 0 1 1-1Z" />
      <path d="m9 15 6-6" />
      <circle cx="9" cy="9" r=".75" />
      <circle cx="15" cy="15" r=".75" />
    </>
  ),
  "chevron-down": <path d="m6.5 9.25 5.5 5.5 5.5-5.5" />,
};

export default function CodFieldIcon({ name, className = "" }) {
  const content = ICON_CONTENT[name] || ICON_CONTENT.user;

  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={name === "discount" ? "1.75" : "1.8"}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      data-icon-name={name}
    >
      {content}
    </svg>
  );
}
